import { sum } from 'lodash';

export const getRowValues = (rows, id) => (rows ? rows.map(row => row.values[id]) : 0);

export const simpleSum = (rows, id) => sum(getRowValues(rows, id));

export const safeDivide = (numerator, denominator) => (denominator > 0 ? numerator / denominator : 0);

export const ratio = (rows, numeratorId, denominatorId) => {
    const numerator = simpleSum(rows, numeratorId);
    const denominator = simpleSum(rows, denominatorId);

    return safeDivide(numerator, denominator);
};



// WEBPACK FOOTER //
// ./src/components/atoms/tables/smarttables/helpers/aggregations.js